import { Field } from 'formik';
import type { FieldProps } from 'formik';

import {
  TeamMemberSelect,
  UNASSIGNED_OPTION,
} from 'modules/common/smartComponents/TeamMemberSelect';

import type { FormData } from '../types';
import { HorizontalFormControl } from './HorizontalFormControl';

export const SalespersonFilter = () => {
  return (
    <HorizontalFormControl label="Salesperson">
      <Field name="salespersonIn">
        {({ field, form }: FieldProps<FormData['salespersonIn'], FormData>) => (
          <TeamMemberSelect
            isMulti
            mode="assignmentFilter"
            onChange={(selectedSalespersons) => {
              if (selectedSalespersons.includes(UNASSIGNED_OPTION)) {
                form.setFieldValue(field.name, []);
                form.setFieldValue('salespersonIsUnassigned', true);
              } else {
                form.setFieldValue(
                  field.name,
                  selectedSalespersons.map(({ value }) => value),
                );
                form.setFieldValue('salespersonIsUnassigned', false);
              }
            }}
            value={
              form.values.salespersonIsUnassigned
                ? [UNASSIGNED_OPTION]
                : field.value
            }
          />
        )}
      </Field>
    </HorizontalFormControl>
  );
};
